<template>
  <b-card class="support-card">
    <b-card-title class="card-title px-4">
      {{ title }}
    </b-card-title>
    <b-card-body class="card-body p-0">
      <b-card-img class="card-img" :src="img">
      </b-card-img>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "SupportCard",
  props: {
    title: String,
    img: String
  }
}
</script>

<style scoped>
.support-card {
  background-color: transparent;
  width: 350px;
  border: none;
  border-radius: 0;
}

.card-title {
  font-family: "Gotham Book", serif;
  font-size: 16px;
  height: 100px;
}

.card-img {
  width: 250px;
  height: 240px;
  object-fit: cover;
}
</style>